import { lazy } from 'react';
import paths from 'app/router/paths';
import {
  getRestaurantProfileAttributesConfigCall,
  getRestaurantProfileSettingsCall,
} from 'api/app/restaurant/settings/websiteBuilder';

const RestaurantProfilePage = lazy(
  () => import('app/pages/RestaurantSettings/WebsiteBuilder/RestaurantProfile'),
);
const Gallery = lazy(() => import('app/pages/RestaurantSettings/Gallery'));

const websiteBuilder = [
  {
    path: paths.settings.websiteBuilder.restaurantProfile,
    element: <RestaurantProfilePage />,
    loader: async () =>
      await Promise.all([
        getRestaurantProfileAttributesConfigCall(),
        getRestaurantProfileSettingsCall(),
      ]),
  },
  {
    path: paths.settings.websiteBuilder.gallery,
    element: <Gallery />,
  },
];

export default websiteBuilder;
